import React, { useEffect, memo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import Alert from '@mui/material/Alert';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import { alertActions } from '@/store/actions/alert.actions';

const AppAlert = ({className = ''}) => {
	const ref = useRef({
		lastChangeTime: 0,
	});
	const dispatch = useDispatch();
	const {type: alertType, text: alertText} = useSelector(state => state.alert);

	useEffect(() => {
		ref.current.lastChangeTime = Date.now();
	}, [ alertText ]);

	useEffect(() => {
		return () => {			
			if ( Date.now() - ref.current.lastChangeTime > 2000 ) {
				dispatch(alertActions.clearAlert());
			}
		};
	}, []);

	return (
		<>
			{ alertType &&  alertText && (
				<Alert 
					onClose={ () => dispatch(alertActions.clearAlert()) }
					severity={ alertType }
					iconMapping={ {
						success: <CheckCircleOutlineOutlinedIcon /> ,
					} }
					className={ className }
				>
					{alertText}
				</Alert>
			)}
		</>
	);
};

AppAlert.propTypes = {
	className: PropTypes.string,
};

export default memo(AppAlert);